import { globalStyles } from "../../../../../../styles/globalStyleTheming";

export const incidentMarker = (
  <svg
    width="28"
    height="36"
    viewBox="-5 -1.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin"
  >
    <path
      fill={globalStyles.palette.primary.main}
      d="M7 20.565c-4.667-6.09-7-10.423-7-13a7 7 0 1 1 14 0c0 2.577-2.333 6.91-7 13zm0-8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
    />
  </svg>
);
